import React, { useEffect, useState } from 'react'
import { AddiWarranty_GetrowApi, AddiWarranty_SaveApi, Search_Exact_ItemAPI } from '../../Server/ApiV2';
import { exportToExcel, fAlertToast, getUniqueValues  } from '../../Utility/Utilitys';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button, IconButton, InputAdornment, Stack, TextField, Tooltip } from '@mui/material';
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowForwardIos } from "@mui/icons-material";
import NumericCell from './components/NumericCell';
import { createMultiSelectOperator } from '../../Component/Common/ReuseableComponent/DatagridFilterColumnComp';

  const breadCrumbStyle = {
    color: "#cccccc",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  const breadCrumbActiveStyle = {
    color: "#0288d1",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

export default function InsuranceSetup() {
 const [gridData, setGridData] = useState([]);

  const fGetrow = async () => {
    try {
      const resp = await AddiWarranty_GetrowApi({});
      if (resp?.status === 200) setGridData(resp?.data?.ResultSet || []);
      else {
        fAlertToast("FAILED", resp?.response?.data?.error || resp?.message);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fGetrow();
  }, []);


const updateInput = (newValue, params) => {
  setGridData((prev) =>
    prev.map((row) =>
      row.id === params.id
        ? {
            ...row,
            [params.field]: newValue,
            IsRowEdited: true, // <- set here
          }
        : row
    )
  );
};

const handleExactItmSearch = async (e, field, value, rowId) => {
  const blocked = [
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
  ];
  if (blocked.includes(e.key)) e.stopPropagation();
  if (e.key === " ") e.stopPropagation();
  if (e.key === "Enter" || e.type === "click" || e._reactName === "onClick") {
    if (value.trim().length === 0) {
      fAlertToast("INFO", "Please enter a value");
      return;
    }
    const obj = {
      anyData: value ?? "",
      transType: "F",
      report: "Y",
      loc: "",
    };
    try {
      const response = await Search_Exact_ItemAPI(obj);
      if (response?.status === 200) {
        const list = response?.data?.ResultSet || [];
        if (list.length > 0) {
          const item = list[0];

          // 🔹 ItmCd1 -> ItmName1, ItmCd2 -> ItmName2, ItmCd3 -> ItmName3
          const nameField = field.replace("Cd", "Name");

          setGridData((prev) =>
            prev.map((row) =>
              row.id === rowId
                ? {
                    ...row,
                    [nameField]: item?.Name1 || "",
                    IsRowEdited: true,
                  }
                : row
            )
          );
        }
      }
    } catch (err) {
      console.error("Search_Exact_ItemAPI error:", err);
      fAlertToast("FAILED", err?.response?.data?.message || err?.message);
    }
  }
};

  const fSave = async () => {
    try {
      const editedRows = gridData?.filter((row) => row.IsRowEdited);
      if (editedRows.length === 0) {
        fAlertToast(
          "WARNING",
          "No updates detected. Please edit a row before saving."
        );
        return;
      }
      const payload = editedRows?.map((item) => {
        const {
          ItmName1,
          ItmName2,
          ItmName3,
          id,
          Name1,
          IsRowEdited,
          Typ,
          ...restPayload
        } = item;
        return restPayload;
      });
      //   let FinalObj = fcheck_null_undefine_replace_empty(payload);
      const resp = await AddiWarranty_SaveApi({Typ:editedRows[0]?.Typ,detail:payload});
      if (resp?.status === 200) {
        fAlertToast("SUCCESS", "Data saved successfully");
        fGetrow();
      } else {
        fAlertToast("FAILED", resp?.response?.data?.error || resp?.message);
      }
    } catch (error) {}
  };

  const uniqueCategoryValues = getUniqueValues(gridData, "Name1");

const columns = [
  {
    field: "Name1",
    headerName: "Category",
    minWidth: 180,
    flex: 1,
    filterOperators: [createMultiSelectOperator(uniqueCategoryValues)],
  },
  {
    field: "Typ",
    headerName: "Type",
    width: 40,
  },
  {
    field: "OneYear_AddiPerc",
    headerName: "1 Year Addi %",
    width: 95,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "OneYear_AddiCustPerc",
    headerName: "1 Year Cust %",
    width: 95,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "TwoYear_AddiPerc",
    headerName: "2 Year Addi %",
    width: 95,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "TwoYeart_AddiCustPerc",
    headerName: "2 Year Cust %",
    width: 95,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "Primary_AddiPerc",
    headerName: "Primary Addi %",
    width: 110,
    hide: true,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "Primary_AddiCustPerc",
    headerName: "Primary Cust %",
    type: "number",
    width: 110,
    hide: true,
    renderCell: (params) => (
      <NumericCell
        key={`${params.id}-${params.field}`}
        value={params.row[params.field]}
        onValueChange={(newValue) => {
          updateInput(newValue, params);
        }}
      />
    ),
  },
  {
    field: "ItmCd1",
    headerName: "Item Code 1",
    width: 150,
    renderCell: ({ row }) => (
      <TextField
        fullWidth
        autoComplete="off"
        size="small"
        type="text"
        value={row.ItmCd1 || ""}
        onChange={(e) => {
          const newValue = e.target.value;

          setGridData((prev) =>
            prev.map((r) =>
              r.id === row.id
                ? {
                    ...r,
                    ItmCd1: newValue,
                    ItmName1: newValue.trim() === "" ? "" : r.ItmName1,
                  }
                : r
            )
          );
        }}
        onKeyDown={(e) => handleExactItmSearch(e, "ItmCd1", row.ItmCd1, row.id)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              <SearchIcon
                onClick={(e) =>
                  handleExactItmSearch(e, "ItmCd1", row.ItmCd1, row.id)
                }
              />
            </InputAdornment>
          ),
        }}
      />
    ),
  },
  {
    field: "ItmName1",
    headerName: "Item Name 1",
    minWidth: 180,
    flex: 1,
  },
  {
    field: "ItmCd2",
    headerName: "Item Code 2",
    width: 150,
    renderCell: ({ row }) => (
      <TextField
        fullWidth
        autoComplete="off"
        size="small"
        type="text"
        value={row.ItmCd2 || ""}
        onChange={(e) => {
          const newValue = e.target.value;
          setGridData((prev) =>
            prev.map((r) =>
              r.id === row.id
                ? {
                    ...r,
                    ItmCd2: newValue,
                    ItmName2: newValue.trim() === "" ? "" : r.ItmName2,
                  }
                : r
            )
          );
        }}
        onKeyDown={(e) => handleExactItmSearch(e, "ItmCd2", row.ItmCd2, row.id)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              <SearchIcon
                onClick={(e) =>
                  handleExactItmSearch(e, "ItmCd2", row.ItmCd2, row.id)
                }
              />
            </InputAdornment>
          ),
        }}
      />
    ),
  },
  {
    field: "ItmName2",
    headerName: "Item Name 2",
    minWidth: 180,
    flex: 1,
  },
  {
    field: "ItmCd3",
    headerName: "Item Code 3",
    width: 150,
    hide: true,
    renderCell: ({ row }) => (
      <TextField
        fullWidth
        autoComplete="off"
        size="small"
        type="text"
        value={row.ItmCd3 || ""}
        onChange={(e) => {
          const newValue = e.target.value;
          setGridData((prev) =>
            prev.map((r) =>
              r.id === row.id
                ? {
                    ...r,
                    ItmCd3: newValue,
                    ItmName3: newValue.trim() === "" ? "" : r.ItmName3,
                  }
                : r
            )
          );
        }}
        onKeyDown={(e) => handleExactItmSearch(e, "ItmCd3", row.ItmCd3, row.id)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              <SearchIcon
                onClick={(e) =>
                  handleExactItmSearch(e, "ItmCd3", row.ItmCd3, row.id)
                }
              />
            </InputAdornment>
          ),
        }}
      />
    ),
  },
  {
    field: "ItmName3",
    headerName: "Item Name 3",
    minWidth: 180,
    flex: 1,
    hide: true,
  },
];

  return (
    <Box p={2}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ mb: 1 }}>
          <span style={breadCrumbStyle}>Masters </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "0.5rem" }} />
          <span style={breadCrumbActiveStyle}>Insurance Setup</span>
        </Box>
        <Tooltip title="Export CSV">
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              exportToExcel(gridData, "InsuranceSetup", "");
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        sx={{
          height: { xs: "80vh", lg: "81vh"},
          marginTop: 1,
        }}
      >
      <DataGridPro
        rows={gridData??[]}
        columns={columns}
        disableRowSelectionOnClick
        rowHeight={30}
        headerHeight={40}
        hideFooter
        sx={{
          border: 1,
          borderColor: "primary.light",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#0d73bb",
            color: "white",
          },
        }}
      />
      <Stack
        direction="row" 
        justifyContent="flex-end" mt={1}>
            <Button variant="contained" size="small" color='success' onClick={fSave}>Save</Button>
        </Stack>
      </Box>
    </Box>
  );
}
